import { Box } from '@material-ui/core';
import styles from './index.module.css';

// `hideTitle` is intentionally accepted but unused — titles are no longer
// hidden in any mode (gift / non-gift). Prop kept in the signature so the
// many call sites that still pass `hideTitle={hideVideoTitles}` keep
// compiling without code churn.
// eslint-disable-next-line no-unused-vars
export function TitleLabel({ title, category, hideTitle }) {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" m="2px">

            <h4 style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '17ch',
              zIndex: 1,
              margin: '0px'
            }}
            >
              {title}
            </h4>
            {
                category
            && <h6 style={{ margin: '0px', color: 'white' }}>{category}</h6>
            }

        </Box>
    );
}
